import { Injectable } from '@angular/core';
import { Frame, Stomp } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WebsocketService {
  private stompClient: any;
  public notifications = new Subject<any>();
  private API = environment.websocketUrl;

  connect(userId: string) {
    const socket = new SockJS(`${this.API}/ws`);
    this.stompClient = Stomp.over(socket);
    this.stompClient.connect({}, (frame: Frame) => {
      this.stompClient.subscribe('/topic/notifications/public', (msg: any) => {
        this.notifications.next(JSON.parse(msg.body));
      });
      // For user-specific: this.stompClient.subscribe(`/topic/notifications/user/${userId}`, ...);

      if (userId) {
        this.stompClient.subscribe(`/topic/notifications/user/${userId}`, (msg: any) => {
          const data = JSON.parse(msg.body);
          this.notifications.next(data);
        });
      }
    });
  }

  disconnect() {
    if (this.stompClient) this.stompClient.disconnect();
  }
}
